const menyer = [

  {
    id: 1,
    namn: "start",
    mat: function () {
      return (
        <>
          <h3>Silltallrik</h3>3 sorters sill, gräddfil med gräslök, gubbröra,
          ägg, potatis, västerbottenpaj, rågbröd, knäckebröd och smör – 175 kr

          <h3>Husets köttbullar</h3>
          med potatis, rårörda lingon, pressgurka och gräddsås  – 175 kr

          <h3>Paj med sallad</h3>
          Fetaost och spenat - 125 kr

          <h3>Räksmörgås</h3>
          Handskalade stora räkor på rågbröd – 159 kr

          <h3>Grillsmörgås med sallad</h3>
          Ost och skinka med dijonsenap - 110 kr
          <br />
          Chevré, valnötter och honung - 115 kr

          <h3>Pannkakor</h3>
          med sylt och grädde, 2 eller 3 st. – 70/90 kr

        </>
      );
    },
    mat_en: function () {
      return (
        <>
          <h3>Herring Platter</h3>3 kinds of herring, sour cream with chives, egg mixture,
          egg, potatoes, Västerbotten cheese pie, rye bread, crispbread and butter – SEK 175

          <h3>House Meatballs</h3>
          with potatoes, lingonberry jam, pickled cucumber and cream sauce – SEK 175

          <h3>Pie with Salad</h3>
          Feta cheese and spinach – SEK 125

          <h3>Prawn Sandwich</h3>
          Hand-peeled large prawns on rye bread – SEK 159

          <h3>Grilled Sandwich with Salad</h3>
          Cheese and ham with Dijon mustard – SEK 110
          <br />
          Chèvre, walnuts and honey – SEK 115

          <h3>Pancakes</h3>
          with jam and cream, 2 or 3 pcs – SEK 70/90

        </>
      );
    },
    mat_de: function () {
      return (
        <>
          <h3>Heringsplatte</h3>3 Sorten Hering, Sauerrahm mit Schnittlauch, Eiermischung,
          Ei, Kartoffeln, Västerbotten-Käsepastete, Roggenbrot, Knäckebrot und Butter – 175 SEK

          <h3>Hausgemachte Fleischbällchen</h3>
          mit Kartoffeln, Preiselbeeren, eingelegter Gurke und Sahnesauce – 175 SEK

          <h3>Pastete mit Salat</h3>
          Fetakäse und Spinat – 125 SEK

          <h3>Garnelenbrötchen</h3>
          Handgeschälte große Garnelen auf Roggenbrot – 159 SEK

          <h3>Grillsandwich mit Salat</h3>
          Käse und Schinken mit Dijonsenf – 110 SEK
          <br />
          Ziegenkäse, Walnüsse und Honig – 115 SEK

          <h3>Pfannkuchen</h3>
          mit Marmelade und Sahne, 2 oder 3 Stk. – 70/90 SEK

        </>
      );
    },
  },
  {
    id: 2,
    namn: "påsk",
    mat: function () {
      return (
        <>
          <h3>Påsktallrik</h3>
          3 sorters sill, rökt lax, gubbröra, gräddfil med gräslök, ägghalvor, potatis, västerbottenostpaj, rågbröd, knäckebröd och smör – 185 kr

          <h3>Paj med sallad</h3>
          Fetaost och spenat - 125 kr

          <h3>Räksmörgås</h3>
          Handskalade stora räkor på rågbröd – 159 kr

          <h3>Smörrebröd</h3>
          Kallrökt lax med citronkräm – 99 kr

          <h3>Grillsmörgås med sallad</h3>
          Ost och skinka med dijonsenap - 105 kr
          <br />
          Chevré, valnötter och honung - 109 kr

          <h3>Pannkakor</h3>
          med sylt och grädde, 2 eller 3 st. – 70/90 kr

        </>
      );
    },
    mat_en: function () {
      return (
        <>
          <h3>Easter Platter</h3>
          3 kinds of herring, smoked salmon, egg mixture, sour cream with chives, egg halves, potatoes, Västerbotten cheese pie, rye bread, crispbread and butter – SEK 185

          <h3>Pie with Salad</h3>
          Feta cheese and spinach – SEK 125

          <h3>Prawn Sandwich</h3>
          Hand-peeled large prawns on rye bread – SEK 159

          <h3>Open-faced Sandwich</h3>
          Cold-smoked salmon with lemon cream – SEK 99

          <h3>Grilled Sandwich with Salad</h3>
          Cheese and ham with Dijon mustard – SEK 105
          <br />
          Chèvre, walnuts and honey – SEK 109

          <h3>Pancakes</h3>
          with jam and cream, 2 or 3 pcs – SEK 70/90

        </>
      );
    },
    mat_de: function () {
      return (
        <>
          <h3>Osterplatte</h3>
          3 Sorten Hering, Räucherlachs, Eiermischung, Sauerrahm mit Schnittlauch, Eierhälften, Kartoffeln, Västerbotten-Käsepastete, Roggenbrot, Knäckebrot und Butter – 185 SEK

          <h3>Pastete mit Salat</h3>
          Fetakäse und Spinat – 125 SEK

          <h3>Garnelenbrötchen</h3>
          Handgeschälte große Garnelen auf Roggenbrot – 159 SEK

          <h3>Smørrebrød</h3>
          Kaltgeräucherter Lachs mit Zitronencreme – 99 SEK

          <h3>Grillsandwich mit Salat</h3>
          Käse und Schinken mit Dijonsenf – 105 SEK
          <br />
          Ziegenkäse, Walnüsse und Honig – 109 SEK

          <h3>Pfannkuchen</h3>
          mit Marmelade und Sahne, 2 oder 3 Stk. – 70/90 SEK

        </>
      );
    },
  },
  {
    id: 3,
    namn: "juli",
    mat: function () {
      return (
        <>
          {/* 
          <h3>Skärgårdstallrik</h3>Varmrökt lax, 3 sorters sill, gubbröra, västerbottenpaj, gräddfil med gräslök, färskpotatis, rågbröd, knäckebröd och smör – 255 kr
          
          <h3>Varmrökt lax med romsås</h3>färskpotatis och sallad – 219 kr
        */}

          <h3>Silltallrik</h3>3 sorters sill, gubbröra, västerbottenpaj, gräddfil med gräslök,
          ägg, färskpotatis, rågbröd, knäckebröd och smör – 175 kr

          <h3>Husets köttbullar</h3>
          med potatis, rårörda lingon, pressgurka och gräddsås  – 175 kr

          <h3>Paj med sallad</h3>
          Lax och spenat – 125 kr<br />
          Fetaost och spenat – 125 kr
          {/* 
          <h3>Lasagne med sallad</h3>
          Bolognese – 145 kr<br />
          Vegetarisk – 145 kr
        */}

          <h3>Räksmörgås</h3>
          Handskalade lyxräkor på rågbröd – 159 kr

          {/* 
          <h3>Smörrebröd</h3>
          Kallrökt lax med citronkräm – 105 kr
        */}

          <h3>Grillsmörgås med sallad</h3>
          Ost och skinka med dijonsenap – 110 kr<br />
          Chevré, valnötter och honung – 115 kr

          <h3>Barnmeny</h3>
          Pannkakor med sylt och grädde, 2 eller 3 st. – 70/90 kr
        </>
      );
    },
    mat_en: function () {
      return (
        <>
          <h3>Archipelago Platter</h3>Hot-smoked salmon, 3 kinds of herring, egg mixture, Västerbotten cheese pie, sour cream with chives, new potatoes, rye bread, crispbread and butter – SEK 255

          {/* 
            <h3>Hot-smoked Salmon with Roe Sauce</h3>new potatoes and salad – SEK 219
          */}


          <h3>Herring Platter</h3>3 kinds of herring, egg mixture, Västerbotten cheese pie, sour cream with chives,
          egg, new potatoes, rye bread, crispbread and butter – SEK 175

          <h3>Pie with Salad</h3>
          Salmon and spinach – SEK 125<br />
          Feta cheese and spinach – SEK 125

          {/* 
          <h3>Lasagne with Salad</h3>
          Bolognese – SEK 145<br />
          Vegetarian – SEK 145
          */}


          <h3>Prawn Sandwich</h3>
          Hand-peeled luxury prawns on rye bread – SEK 159

          <h3>Open-faced Sandwich</h3>
          Cold-smoked salmon with lemon cream – SEK 105

          <h3>Grilled Sandwich with Salad</h3>
          Cheese and ham with Dijon mustard – SEK 110<br />
          Chèvre, walnuts and honey – SEK 115

          <h3>Children's Menu</h3>
          Pancakes with jam and cream, 2 or 3 pcs – SEK 70/90
        </>
      );
    },
    mat_de: function () {
      return (
        <>
          <h3>Schärenplatte</h3>Warmgeräucherter Lachs, 3 Sorten Hering, Eiermischung, Västerbotten-Käsepastete, Sauerrahm mit Schnittlauch, neue Kartoffeln, Roggenbrot, Knäckebrot und Butter – 255 SEK
          {/* 
          <h3>Warmgeräucherter Lachs mit Rogen-Sauce</h3>neue Kartoffeln und Salat – 219 SEK
          */}


          <h3>Heringsplatte</h3>3 Sorten Hering, Eiermischung, Västerbotten-Käsepastete, Sauerrahm mit Schnittlauch,
          Ei, neue Kartoffeln, Roggenbrot, Knäckebrot und Butter – 175 SEK

          <h3>Pastete mit Salat</h3>
          Lachs und Spinat – 125 SEK<br />
          Fetakäse und Spinat – 125 SEK

          {/* 
          <h3>Lasagne mit Salat</h3>
          Bolognese – 145 SEK<br />
          Vegetarisch – 145 SEK
          */}

          <h3>Garnelenbrötchen</h3>
          Handgeschälte Luxus-Garnelen auf Roggenbrot – 159 SEK

          <h3>Smørrebrød</h3>
          Kaltgeräucherter Lachs mit Zitronencreme – 105 SEK

          <h3>Grillsandwich mit Salat</h3>
          Käse und Schinken mit Dijonsenf – 110 SEK<br />
          Ziegenkäse, Walnüsse und Honig – 115 SEK

          <h3>Kindermenü</h3>
          Pfannkuchen mit Marmelade und Sahne, 2 oder 3 Stk. – 70/90 SEK
        </>
      );
    },
  },

  {
    id: 4,
    namn: "sensommar",
    mat: function () {
      return (
        <>
          <h3>Husets köttbullar</h3>
          med potatis, rårörda lingon, pressgurka och gräddsås  – 175 kr

          <h3>Silltallrik</h3>3 sorters sill, gubbröra, västerbottenpaj, gräddfil med gräslök,
          ägg, färskpotatis, rågbröd, knäckebröd och smör – 159 kr

          <h3>Köttbullesmörgås</h3>
          på tekaka med rödbetssallad – 108 kr

          <h3>Barnmeny</h3>
          Pannkakor med sylt och grädde, 2 eller 3 st. – 70/90 kr
        </>
      );
    },
    mat_en: function () {
      return (
        <>
          <h3>House Meatballs</h3>
          with potatoes, lingonberry jam, pickled cucumber and cream sauce – SEK 175

          <h3>Herring Platter</h3>3 kinds of herring, egg mixture, Västerbotten cheese pie, sour cream with chives,
          egg, new potatoes, rye bread, crispbread and butter – SEK 159

          <h3>Meatball Sandwich</h3>
          on soft flatbread with beetroot salad – SEK 108

          <h3>Children's Menu</h3>
          Pancakes with jam and cream, 2 or 3 pcs – SEK 70/90
        </>
      );
    },
    mat_de: function () {
      return (
        <>
          <h3>Hausgemachte Fleischbällchen</h3>
          mit Kartoffeln, Preiselbeeren, eingelegter Gurke und Sahnesauce – 175 SEK

          <h3>Heringsplatte</h3>3 Sorten Hering, Eiermischung, Västerbotten-Käsepastete, Sauerrahm mit Schnittlauch,
          Ei, neue Kartoffeln, Roggenbrot, Knäckebrot und Butter – 159 SEK

          <h3>Fleischbällchen-Sandwich</h3>
          auf Fladenbrot mit Rote-Bete-Salat – 108 SEK

          <h3>Kindermenü</h3>
          Pfannkuchen mit Marmelade und Sahne, 2 oder 3 Stk. – 70/90 SEK
        </>
      );
    },
  },

  {
    id: 5,
    namn: "höst",
    mat: function () {
      return (
        <>
          <h3>Portergryta</h3>
          på högrev, med vinbärsgele, potatis och sallad - 175 kr

          <h3>Paj med sallad</h3>
          Lax och spenat - 125 kr
          <br />
          Fetaost och spenat - 125 kr

          <h3>Räksmörgås</h3>
          Handskalade lyxräkor på rågbröd – 159 kr

          <h3>Grillsmörgås med sallad</h3>
          Ost och skinka med dijonsenap - 105 kr

          <h3>Barnmeny</h3>
          Pannkakor med sylt och grädde, 2 eller 3 st. – 70/90 kr
        </>
      );
    },
    mat_en: function () {
      return (
        <>
          <h3>Porter Stew</h3>
          chuck beef with currant jelly, potatoes and salad – SEK 175

          <h3>Pie with Salad</h3>
          Salmon and spinach – SEK 125
          <br />
          Feta cheese and spinach – SEK 125

          <h3>Prawn Sandwich</h3>
          Hand-peeled luxury prawns on rye bread – SEK 159

          <h3>Grilled Sandwich with Salad</h3>
          Cheese and ham with Dijon mustard – SEK 105

          <h3>Children's Menu</h3>
          Pancakes with jam and cream, 2 or 3 pcs – SEK 70/90
        </>
      );
    },
    mat_de: function () {
      return (
        <>
          <h3>Porter-Eintopf</h3>
          Rindfleisch mit Johannisbeergelee, Kartoffeln und Salat – 175 SEK

          <h3>Pastete mit Salat</h3>
          Lachs und Spinat – 125 SEK
          <br />
          Fetakäse und Spinat – 125 SEK

          <h3>Garnelenbrötchen</h3>
          Handgeschälte Luxus-Garnelen auf Roggenbrot – 159 SEK

          <h3>Grillsandwich mit Salat</h3>
          Käse und Schinken mit Dijonsenf – 105 SEK

          <h3>Kindermenü</h3>
          Pfannkuchen mit Marmelade und Sahne, 2 oder 3 Stk. – 70/90 SEK
        </>
      );
    },
  },

  {
    id: 6,
    namn: "jul",
    mat: function () {
      return (
        <>
          <h3>Jultallrik</h3>
          julskinka, kallrökt lax, 3 sorters sill, hovmästarsås, senap, rödbetssallad, gräddfil, gräslök, julost, potatis och vörtbröd - 155 kr.

          <h3>Paj med sallad</h3>
          Lax och spenat - 125 kr

          <h3>Grillsmörgås med sallad</h3>
          Ost och skinka med dijonsenap - 105 kr

          <h3>Smörrebröd</h3>
          Kallrökt lax med citronkräm – 99 kr

          <h3>Barnmeny</h3>
          Pannkakor med sylt och grädde, 2 eller 3 st. – 70/90 kr
        </>
      );
    },
    mat_en: function () {
      return (
        <>
          <h3>Christmas Platter</h3>
          Christmas ham, cold-smoked salmon, 3 kinds of herring, hovmästarsås (sweet mustard sauce), mustard, beetroot salad, sour cream, chives, Christmas cheese, potatoes and wort bread – SEK 155.

          <h3>Pie with Salad</h3>
          Salmon and spinach – SEK 125

          <h3>Grilled Sandwich with Salad</h3>
          Cheese and ham with Dijon mustard – SEK 105

          <h3>Open-faced Sandwich</h3>
          Cold-smoked salmon with lemon cream – SEK 99

          <h3>Children's Menu</h3>
          Pancakes with jam and cream, 2 or 3 pcs – SEK 70/90
        </>
      );
    },
    mat_de: function () {
      return (
        <>
          <h3>Weihnachtsplatte</h3>
          Weihnachtsschinken, kaltgeräucherter Lachs, 3 Sorten Hering, Hovmästarsås (süße Senfsauce), Senf, Rote-Bete-Salat, Sauerrahm, Schnittlauch, Weihnachtskäse, Kartoffeln und Würzbrot – 155 SEK.

          <h3>Pastete mit Salat</h3>
          Lachs und Spinat – 125 SEK

          <h3>Grillsandwich mit Salat</h3>
          Käse und Schinken mit Dijonsenf – 105 SEK

          <h3>Smørrebrød</h3>
          Kaltgeräucherter Lachs mit Zitronencreme – 99 SEK

          <h3>Kindermenü</h3>
          Pfannkuchen mit Marmelade und Sahne, 2 oder 3 Stk. – 70/90 SEK
        </>
      );
    },
  },

  {
    id: 7,
    namn: "midsommar",
    mat: function () {
      return (
        <>
          <h3>Midsommartallrik</h3>
          3 sorters sill, varmrökt lax, räkröra, gräddfil, gräslök, kokt ägg, färskpotatis, smör och bröd - 245 kr

          <h3>Räksmörgås</h3>
          Handskalade lyxräkor på rågbröd – 159 kr

          <h3>Barnmeny</h3>
          Pannkakor med sylt och grädde, 2 eller 3 st. – 70/90 kr

          <h3>Jordgubbstårta</h3>
          Citronkrän, jordgubbsmousse, grädde och färska jordgubbar – 75kr
        </>
      );
    },
    mat_en: function () {
      return (
        <>
          <h3>Midsummer Platter</h3>
          3 kinds of herring, hot-smoked salmon, prawn mixture, sour cream, chives, boiled egg, new potatoes, butter and bread – SEK 245

          <h3>Prawn Sandwich</h3>
          Hand-peeled luxury prawns on rye bread – SEK 159

          <h3>Children's Menu</h3>
          Pancakes with jam and cream, 2 or 3 pcs – SEK 70/90

          <h3>Strawberry Cake</h3>
          Lemon cream, strawberry mousse, whipped cream and fresh strawberries – SEK 75
        </>
      );
    },
    mat_de: function () {
      return (
        <>
          <h3>Mittsommerplatte</h3>
          3 Sorten Hering, warmgeräucherter Lachs, Garnelenmischung, Sauerrahm, Schnittlauch, gekochtes Ei, neue Kartoffeln, Butter und Brot – 245 SEK

          <h3>Garnelenbrötchen</h3>
          Handgeschälte Luxus-Garnelen auf Roggenbrot – 159 SEK

          <h3>Kindermenü</h3>
          Pfannkuchen mit Marmelade und Sahne, 2 oder 3 Stk. – 70/90 SEK

          <h3>Erdbeertorte</h3>
          Zitronencreme, Erdbeermousse, Schlagsahne und frische Erdbeeren – 75 SEK
        </>
      );
    },
  },
];

const dagens = menyer.filter((obj) => obj.namn === "juli")[0];

export default dagens;
